import moment from "moment"
import PropTypes from "prop-types"
import React, { useEffect } from "react"
import styled from "styled-components"
import * as Yup from "yup"

import BottomSheet from "../../../../_shared/components/BottomSheet"
import AppDatePicker from "../../../../_shared/components/FormItems/AppDatePicker"
import FormInput from "../../../../_shared/components/FormItems/FormInput"
import useFormikForm from "../../../../_shared/hooks/useFormikForm"

// ----------------------------------------------------------------------------

function _TenanciesBottomSheet(props) {
    // -------------------------------------
    // Props destructuring
    // -------------------------------------

    const { className, open, onConfirm, onCancel, defaultValues } = props

    // -------------------------------------
    // Hooks (e.g. useState, ...)
    // -------------------------------------

    const initialValues = {
        room: "",
        startDate: "",
        endDate: "",
        tenant: {
            fullName: "",
            identityCardNumber: "",
            email: "",
            birthPlace: "",
            birthDate: "",
        },
    }

    const validationSchema = new Yup.ObjectSchema({
        room: Yup.string(),
        startDate: Yup.object().nullable().required("Campo obbligatorio"),
        endDate: Yup.object()
            .nullable()
            .required("Campo obbligatorio")
            .when("startDate", (startDate) => {
                return Yup.object().test(
                    "is-after-start",
                    "La data di fine deve essere dopo la data di inizio",
                    (value) => moment(value).isAfter(moment(startDate))
                )
            }),
    })

    const { reset, bulkChange, getFieldProps, handleSubmit, errors } =
        useFormikForm({
            handleSubmit: handleConfirm,
            initialValues,
            validationSchema,
        })

    // -------------------------------------
    // Memoized values
    // -------------------------------------

    // -------------------------------------
    // Effects
    // -------------------------------------

    useEffect(() => {
        defaultValues
            ? bulkChange({
                  ...defaultValues,
                  startDate: moment(defaultValues.startDate),
                  endDate: moment(defaultValues.endDate),
                  tenant: {
                      ...defaultValues.tenant,
                      birthDate:
                          defaultValues?.tenant?.birthDate &&
                          moment(defaultValues?.tenant?.birthDate),
                  },
              })
            : reset()
    }, [defaultValues])

    // -------------------------------------
    // Component functions
    // -------------------------------------

    function handleConfirm(values) {
        onConfirm && onConfirm(values)
    }

    // -------------------------------------
    // Component local variables
    // -------------------------------------

    return (
        <BottomSheet
            className={`${className}`}
            open={open}
            onConfirm={handleSubmit}
            onCancel={onCancel}
            snapPoint={80}
            title={"Accetta con modifiche"}
        >
            <FormInput
                label="Nome"
                className="field"
                {...getFieldProps("tenant.fullName")}
            />

            <FormInput
                label="E-mail"
                className="field"
                {...getFieldProps("tenant.email")}
            />
            <FormInput
                label="Codice fiscale"
                className="field"
                {...getFieldProps("tenant.fiscalCode")}
            />
            <FormInput
                label="Luogo di nascita"
                className="field"
                {...getFieldProps("tenant.birthPlace")}
            />
            <AppDatePicker
                label="Data di nascita"
                className="field"
                {...getFieldProps("tenant.birthDate")}
            />
            <AppDatePicker
                label="Data di inizio contratto"
                className="field"
                {...getFieldProps("startDate")}
            />
            <AppDatePicker
                label="Data di fine contratto"
                className="field"
                {...getFieldProps("endDate")}
            />
        </BottomSheet>
    )
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

_TenanciesBottomSheet.propTypes = {
    className: PropTypes.string.isRequired,
    open: PropTypes.bool,
    onConfirm: PropTypes.func,
    onCancel: PropTypes.func,
    defaultValues: PropTypes.object,
}

_TenanciesBottomSheet.defaultProps = {}

// ----------------------------------------------------------------------------

const TenanciesBottomSheet = styled(_TenanciesBottomSheet)`
    & {
        .footer {
            margin-right: 40px;
            margin-bottom: 40px;
        }
        .field {
            width: 300px;
            margin-bottom: 20px;
        }
    }
`
// ----------------------------------------------------------------------------

export default TenanciesBottomSheet
